import { useState, useEffect, useContext } from 'react';
import { CasUserContext, useCasUserContext } from '../../services/casUserContext';
import { Alert, AlertTitle, Box, Button, Tab, Tabs, Typography } from '@mui/material';
import { TablaProductoIngresadoDTO } from '../../interfaces/TablaProductoIngresadoDTO';
import { Card, CardBody, CardHeader } from 'reactstrap';
import CatalogService from '../../services/CatalogService';
import ProductoService from '../../services/ProductoService';
import AlertService from '../../services/AlertService';
import ProductosIngresados from './ProductosIngresados';
import ProductosParticipoProyecto from './ProductosParticipoProyecto';
import { useNavigate } from 'react-router-dom';
import { BiPlusCircle } from 'react-icons/bi';
import TableProductosSinProy from './ProductosSinProyecto';
import { ProyectoParticipoDTO } from '../../interfaces/ProyectosDTOS/ProyectoParticipoDTO';
import ProyectoService from '../../services/ProyectoService';

const catalogService = new CatalogService;
const productoService = new ProductoService;
const proyectoService = new ProyectoService;
const alertaService = new AlertService;

const cardHeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export function Productos() {
  //const casUserContext = useContext(CasUserContext);
  const casUserContext = useCasUserContext();
  let history = useNavigate()
  let token = casUserContext.token;
  let idusuarioInv = casUserContext.userData.idpersona;
  let emailInv = casUserContext.userData.emailAddress;
  let [productosIngresados, setProductosIngresados] = useState<Array<TablaProductoIngresadoDTO>>([]);
  let [productosProyecto, setProductosProyecto] = useState<Array<TablaProductoIngresadoDTO>>([]);
  let [productosSinProy, setProductosSinProy] = useState<Array<TablaProductoIngresadoDTO>>([]);
  let [proyParticipo, setProyParticipo] = useState<Array<ProyectoParticipoDTO>>([]);
  let [tabs, setTabs] = useState(0);
  let [readyIng, setReadyIng] = useState(false);
  let [readyPar, setReadyPar] = useState(false);
  let [readySinProy, setReadySinProy] = useState(false);
  //Seccion Funciones
  const goToNavigation = (site: string) => {
    history(site)
  }
  const fetchData = async () => {
    try {
      //  alertaService.showLoading("Cargando Productos..."); 
      await productoService.GetProductosIngresadosUsuario(idusuarioInv, token)
        .then((data) => {
          if (data.status.isSuccessfully) {
            //console.log(data.listData)
            if (productosIngresados.length === 0) {
              setProductosIngresados(data.listData);
              setReadyIng(true);
              let sinProyecto = data.listData.filter(p => p.producto.iddecinvproyecto === 0);
              setProductosSinProy(sinProyecto);
              setReadySinProy(true);
            }
            //alertaService.hideLoading();
          } else {
            // alertaService.hideLoading();
            alertaService.alertaAdvertenciaList("ATENCIÓN", data.status.messages);
          }
        })
        .catch((error) => {
          console.error(error)
          // alertaService.hideLoading();  
        });
      // alertaService.hideLoading();            
    } catch (error) {
      console.error('Error:', error);
    }
    try {
      //  alertaService.showLoading("Cargando Productos...");  
      await productoService.GetProductosProyectosParticipo(idusuarioInv, token)
        .then((data) => {
          if (data.status.isSuccessfully) {
            //console.log(data.listData)
            if (productosProyecto.length === 0) {
              setProductosProyecto(data.listData);
              setReadyPar(true);
            }
            //alertaService.hideLoading(); 
          } else {
            // alertaService.hideLoading();
            alertaService.alertaAdvertenciaList("ATENCIÓN", data.status.messages);
          }
        })
        .catch((error) => {
          console.error(error)
          //alertaService.hideLoading();  
        });
      // alertaService.hideLoading();            
    } catch (error) {
      console.error('Error:', error);
    }
    try {
      //  alertaService.showLoading("Cargando Productos...");  
      await proyectoService.GetProyectosParticipanteByUsermail(emailInv, token)
        .then((data) => {
          if (data.status.isSuccessfully) {
            //console.log(data.listData)
            if (productosProyecto.length === 0) {
              setProyParticipo(data.listData);
              setReadyPar(true);
            }
            //alertaService.hideLoading(); 
          } else {
            // alertaService.hideLoading();
            alertaService.alertaAdvertenciaList("ATENCIÓN", data.status.messages);
          }
        })
        .catch((error) => {
          console.error(error)
          //alertaService.hideLoading();  
        });
      // alertaService.hideLoading();            
    } catch (error) {
      console.error('Error:', error);
    }
  };

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabs(newValue);
  };
  //#region Use Effect
  useEffect(() => {
    fetchData();
  }, [token]);
  //#endregion
  return (
    <>
      <Card>
        <CardHeader style={cardHeaderStyles}>
          <strong>Productos Terminados</strong>
          <Button variant="contained" aria-label="add" endIcon={<BiPlusCircle />} onClick={() => goToNavigation("/Producto/formularioproducto/0")}>
            Nuevo
          </Button>
        </CardHeader>
        <CardBody>
          <Alert severity="warning">
            <AlertTitle>Importante</AlertTitle>
            Le informamos que ahora tiene disponible una opción para importar parte de la información de sus publicaciones desde Scopus. Esta funcionalidad le permitirá facilitar el registro de sus trabajos, tomando automáticamente algunos datos básicos desde la base de datos, sin necesidad de ingresarlos manualmente.
            <br />
            <Button variant="contained" aria-label="add" endIcon={<BiPlusCircle />} onClick={() => goToNavigation("/Producto/ImportScopus/")}>
              Importar
            </Button>
          </Alert>
          <br />
          <Alert severity="info">
            <AlertTitle>Info</AlertTitle>
            Estimado Investigador, en esta sección observara todos sus productos terminados.
          </Alert>
          <br />
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={tabs} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Ingresados" {...a11yProps(0)} />
                <Tab label="Participo" {...a11yProps(1)} />
                <Tab label="Sin Proyecto" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={tabs} index={0}>
              <ProductosIngresados rowsPerPage={[5, 10, 25, 100]} data={productosIngresados} ready={readyIng} mostrarAlert={true} />
            </CustomTabPanel>
            <CustomTabPanel value={tabs} index={1}>
              <ProductosParticipoProyecto rowsPerPage={[5, 10, 25, 100]} data={productosProyecto} proyParticipo={proyParticipo} ready={readyPar} mostrarAlert={true} />
            </CustomTabPanel>
            <CustomTabPanel value={tabs} index={2}>
              <TableProductosSinProy rowsPerPage={[5, 10, 25, 100]} data={productosSinProy} ready={readySinProy} mostrarAlert={true} />
            </CustomTabPanel>
          </Box>
        </CardBody>
      </Card>
    </>
  );
}